import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Globals } from '../../globals';

@Injectable({
  providedIn: 'root',
})
export class AutoLoginService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly globals: Globals = inject(Globals);

  getQbusControlAutoLoginUrl(installationId: number): Observable<string> {
    const url = `${this.globals.apiRoot}/jwtinstallations/${installationId}/qbuscontrol-autologin`;
    return this.http
      .get<{ url: string }>(url)
      .pipe(map((response) => response.url));
  }
}
